import { useEffect, useState } from 'react';
import { adminScopeTerms } from '../../lib/adminScopeTerms';

export const AdminPopulationMetrics = ({ filter, prefix }) => {
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const terms = adminScopeTerms(filter.view_as);
  useEffect(() => {
    let active = true;
    setResult(null); setError(false);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/population-summary?${filter.queryString}`, { credentials: 'include' })
      .then(r => { if (!r.ok) throw new Error('Population unavailable'); return r.json(); })
      .then(d => { if (active) setResult(d); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [filter.queryString, filter.refreshTick]);
  return <section className="mb-6 space-y-3" data-testid={`${prefix}-live-metrics`} aria-busy={!result && !error}>
    <h2 className="text-xs uppercase font-semibold text-[#C9A962]" data-testid={`${prefix}-metrics-heading`}>Live Metrics</h2>
    {error && <div role="alert" className="text-sm text-red-300" data-testid={`${prefix}-metrics-error`}>Metrics unavailable. <button type="button" onClick={filter.refresh} data-testid={`${prefix}-metrics-retry`}>Retry</button></div>}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {[[terms.properties, 'properties'], [terms.occupants, 'occupants'], [terms.staff, 'field_staff']].map(([label, key]) => <div key={key} className="border border-zinc-700 bg-zinc-900 rounded-lg p-4 min-w-0" data-testid={`${prefix}-metric-${key}`}>
          <p className="text-xs text-zinc-400" data-testid={`${prefix}-metric-${key}-label`}>{label}</p>
          <p className="text-2xl font-bold text-white" data-testid={`${prefix}-metric-${key}-value`}>{result?.[key] ?? '—'}</p>
        </div>)}
      </div>
      <details data-testid={`${prefix}-property-types`} className="text-xs text-zinc-300">
        <summary className="cursor-pointer py-1" data-testid={`${prefix}-property-types-toggle`}>{terms.view === 'valet' ? 'Multifamily' : terms.view === 'cleaners' ? '12 commercial types' : 'Multifamily + 12 commercial types'}</summary>
        <ul className="grid sm:grid-cols-2 gap-x-5 gap-y-2 mt-2">{result?.property_types?.map(t => <li className="flex justify-between gap-3" key={t.key} data-testid={`${prefix}-type-${t.key}`}><span>{t.label}</span><span>{t.count}</span></li>)}</ul>
      </details>
  </section>;
};